import { XxsGapCol } from '@xing-com/crate-jobs-components-columns';
import { JobTeaserFacts } from '@xing-com/crate-jobs-components-job-teaser-options';
import { OptimisticPublicationDate } from '@xing-com/crate-jobs-components-optimistic-publication-date';
import { selectJobData } from '@xing-com/crate-jobs-helpers';
import type { JobTeaserCardProps } from '@xing-com/crate-jobs-xinglets';
import { Marker } from '@xing-com/marker';

import * as S from './job-teaser-card.styles';

export const JobTeaserCard: React.FC<JobTeaserCardProps> = ({
  job,
  isNew,
  url,
  routerState,
  target = '_self',
  matchingHighlights,
  actions,
  onClick,
  onContextMenu,
  onAuxClick,
  'data-testid': dataTestId,
  headingLevel = 'h3',
  showRatingMarker,
  showRefreshedDate,
  profileImageSize = 'xsmall',
  profileImageSizeConfined = 'small',
  className,
  'aria-label': ariaLabel,
}) => {
  const {
    activatedAt,
    refreshedAt,
    title,
    location,
    companyName,
    companyLogos,
  } = selectJobData(job);

  return (
    <S.Card
      to={url}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onAuxClick={onAuxClick}
      linkProps={{ target, state: routerState, 'aria-label': ariaLabel }}
      data-testid={dataTestId}
      className={className}
    >
      <S.Article>
        <S.HeaderContainer>
          <S.TopRow>
            <S.Image
              type="company"
              profileName={companyName}
              size={profileImageSize}
              sizeConfined={profileImageSizeConfined}
              src={companyLogos.x1 ?? ''}
              // @ts-expect-error FIXME: SC6
              title={null}
              alt=""
            />
            {matchingHighlights?.highlight ? (
              <Marker variant="highlight">
                {matchingHighlights.highlight.localization.localizationValue}
              </Marker>
            ) : null}
          </S.TopRow>

          <S.Details>
            <XxsGapCol>
              <S.Title
                forwardedAs={headingLevel}
                size="medium"
                data-testid="job-teaser-card-title"
                noMargin
              >
                {title}
              </S.Title>

              {location?.city ? (
                <S.City size="medium" lineHeight="dense" noMargin>
                  {location.city}
                </S.City>
              ) : null}

              <S.Company
                data-testid="job-teaser-card-company"
                size="medium"
                lineHeight="dense"
                noMargin
              >
                {companyName}
              </S.Company>
            </XxsGapCol>
            <JobTeaserFacts
              job={job}
              matchingHighlights={matchingHighlights}
              showRatingMarker={showRatingMarker}
            />
          </S.Details>
          <S.EndRow>
            {typeof activatedAt === 'string' || showRefreshedDate ? (
              <S.Date size="small" lineHeight="dense" noMargin>
                {isNew ? <S.Notification data-testid="mini-badge" /> : null}
                <OptimisticPublicationDate
                  date={
                    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */
                    showRefreshedDate ? refreshedAt : (activatedAt as string)
                  }
                />
              </S.Date>
            ) : null}

            {actions}
          </S.EndRow>
        </S.HeaderContainer>
      </S.Article>
    </S.Card>
  );
};
